/* eslint-disable */
export default {
  _check: 'check',
  _click: 'click',
  _deselect: 'deselect',
  _number_appears: 'number_appears',
  _number_stops: 'number_stops',
  _prize_appears: 'prize_appears',
  _select: 'select',
  _slide_tomb: 'slide_tomb',
  _title: 'title',
  _woosh: 'woosh',
  _wrong_answer: 'wrong_answer',
}